import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Tost, TostTypeEnum } from '../../models/tostes.model';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'que-tost-display',
    imports: [CommonModule, TranslateDirective, TranslatePipe],
    templateUrl: './tost-display.component.html',
    styleUrls: ['./tost-display.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class TostDisplayComponent {
  @Input() tost?: Tost;
  @Output() removeTost = new EventEmitter();
  enumTypeTost = TostTypeEnum;

  constructor() {

  }

  deleteTost() {
    this.removeTost.emit();
  }
}
